import { specialFont } from "../../../Infrastructure/Theme/fontFamily";

export const getAgreementStyles = (theme) => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  modalContent: {
    width: "500px",
    bgcolor: "background.paper",
    borderRadius: "8px",
    boxShadow: 24,
    pt: 4,
    pb: 2,
    px: 4,
    textAlign: "left",
  },
  header: {
    color: theme.palette.primary.main,
    fontFamily: specialFont,
    textTransform: "uppercase",
    fontWeight: "bold",
    marginBottom: "16px",
    fontSize: "16px",
  },
  subheader: {
    color: theme.palette.secondary.main,
    fontWeight: "bold",
    fontSize: "20px",
    marginBottom: "8px",
  },
  body: {
    color: theme.palette.secondary.main,
    fontSize: "14px",
    lineHeight: 1.6,
    marginBottom: "16px",
    maxHeight: "60vh",
    overflowY: "auto",
    pb: 2,
  },
  sectionLi: {
    listStyleType: "none",
    marginBottom: "5px",
  },
  sectionTitle: {
    fontWeight: "bold",
    display: "block",
    mt: 2,
  },
  sectionContent: {
    fontWeight: 400,
    display: "block",
    mb: 2,
  },
  sectionList: {
    listStyleType: "lower-alpha",
    paddingLeft: "20px",
  },
  listItem: {
    marginBottom: "5px",
  },
  listItemText: {
    fontWeight: 400,
  },
  buttonContainer: {
    display: "flex",
    width: "100%",
    justifyContent: "space-between",
    gap: "16px",
    marginTop: "16px",
  },
  cancelButton: {
    color: theme.palette.secondary.main,
    borderColor: theme.palette.secondary.main,
    textTransform: "none",
  },
  acceptButton: {
    backgroundColor: theme.palette.primary.main,
    color: "white",
    textTransform: "none",
    "&:hover": {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});